module.exports = __webpack_public_path__ + "img/feishu.19d13994.webp";